export default __webpack_public_path__ + "static/media/Statistics_2009.10e44028.zip";